import * as React from "react"
import {Box} from "@mui/material";
import {Outlet, useLocation} from "react-router-dom";
import {useEffect} from "react";

import {AppFavIcon, AppFooter, AppLayout} from "../../@componets";
import {appFavicon, menuSize, showHeader} from "../../@signals";
import {useApp} from "../../@hooks"
import MaximalLayoutHeader from "./header";
import {MaximalLayoutConfig} from "./config";
import MaximalLayoutNav from "./Nav";
import {maximalLayoutMainDesktopStyles, maximalLayoutMainMobileStyles} from "./styles";
import {MENU_SIZE} from "../../@constants";


export default function MaximalLayout({ routes=[], config={}, userData={}, components={}, styles={}, links=[], isLocal=false }) {
    const { isDesktop } = useApp()
    const location = useLocation()

    useEffect(() => {
        if (location.pathname !== '/home')
            menuSize.value = MENU_SIZE.MINI
    }, [location.pathname])

    const sxMain = isDesktop ? maximalLayoutMainDesktopStyles() : maximalLayoutMainMobileStyles()

    const handleSetConfig = myConfig => {
        if ( [MENU_SIZE.EXTENDED, MENU_SIZE.MINI].includes(myConfig.menu?.size || MENU_SIZE.EXTENDED) )
            menuSize.value = myConfig.menu?.size || MENU_SIZE.EXTENDED
    }

    return <AppLayout baseConfig={MaximalLayoutConfig} config={config} userData={userData} onSetConfig={handleSetConfig} isLocal={isLocal}>
        { appFavicon.value && <AppFavIcon icon={appFavicon.value} /> }

        { showHeader.value && <MaximalLayoutHeader headerTools={components.headerTools} sx={styles.header} links={links} /> }

        <Box className="content" sx={{ display: { lg: 'flex' }, height: '100%', minHeight: 'calc(100vh - 42px)' }}>
            <MaximalLayoutNav routes={routes} sx={styles.menu} />

            <Box component="main" sx={{ ...sxMain, ...styles.main }}>
                <Outlet />
            </Box>
        </Box>
    </AppLayout>
}